import { ClassicPreset, GetSchemes, NodeEditor } from 'rete';
import { AreaPlugin } from 'rete-area-plugin';
import { AreaExtra, Schemes } from '../rete/helperRete';
import { LocalService, MessageService } from '../../../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../../../common/infrastructure/servicios/MessageService';
import { Router, useRouter } from 'vue-router';
import { Container } from 'inversify';
import { IServiceSearch } from '../../../../../search/application/IServiceSearch';
import { TYPES } from '../../../../../../../common/domain/types';
import HelperLoading from '../../../../../../../common/infrastructure/funciones/HelperLoading';
import { ProcData } from '../../../../../search/domain/search';
import { IapComponent } from '../../../../../component/domain/iapComponent';
import Environment from '../../../../../../../common/domain/constantes/environment';
import { fetchWrapper } from '../../../../../../../common/infrastructure/funciones/helperFetch';
import CatalogObjectTypeConst from '../../../../../catalog/domain/const/CatalogObjectTypeConst';
import CatalogExpConst from '../../../../../catalog/domain/const/CatalogExpConst';
import { IapWorkFlowActivityControl } from '../../../../domain/service/iapWorkFlowActivityControl';
import { ProcedureData } from '../../../../../search/domain/procedureData';
import { ExpresionEngine } from '../../../../../expression/infrastructure/helper/expressionEngine';
import { useStore } from "vuex";
import { IapWorkFlowActivity } from '../../../../domain/service/iapWorkFlowActivity';
import { DisplayComponentControl } from '../controls/displayComponentControl';
import { IapComponentAttribute } from '../../../../../component/domain/iapComponentAttribute';
import EventBus from '../../../../../../../common/infrastructure/event-bus';
import EventConst from '../../../../../../../common/domain/constantes/EventConst';
import DisplayComponentNodeConst from '../constants/DisplayComponentNodeConst';

export class DisplayComponentNode extends ClassicPreset.Node<
  { ejecutar: ClassicPreset.Socket },
  { ejecutar: ClassicPreset.Socket },
  { value: DisplayComponentControl }
> {
  height = 500;
  width = 380;

  //private value: Number;
  private keyEventComponent: string;
  private variableComponentHeader: string;
  private variableComponent: number;
  private variableComponentModal: boolean;
  private variableParamsInput: IapComponentAttribute[];
  private area: AreaPlugin<Schemes, AreaExtra>;
  private updateNode: any;
  private getNodeInternalData: any;
  private showExpression: any;
  private rdControlId: '';
  private router: Router;
  private container: Container | undefined;
  private rootComponentId: number;
  private currentComponentId: number;
  private store: any;
  private activity: IapWorkFlowActivity | undefined;
  private componentData: IapComponent[]
  

  constructor(area: AreaPlugin<Schemes, AreaExtra>, socket: ClassicPreset.Socket, public rootComponentInputId: number, public currentComponentInputId: number, public applicationId: number, public applicationVersion: number, public variableComponentInput: number, public variableComponentHeaderInput: string, public variableComponentModalInput: boolean, public variableComponentParametersInput: [], updateNode: any = undefined, getNodeInternalData: any = undefined, showExpressionFunction: any = undefined, router: Router, container: Container | undefined, storeInput: any, itemActivity: IapWorkFlowActivity | undefined,componentDataInput: IapComponent[]) {
    super("Display Component");
    this.area = area;
    this.updateNode = updateNode;
    this.getNodeInternalData = getNodeInternalData;
    this.showExpression = showExpressionFunction;
    this.variableComponentHeader = variableComponentHeaderInput;
    this.variableComponent = variableComponentInput;
    this.variableComponentModal = variableComponentModalInput;
    this.variableParamsInput = variableComponentParametersInput;
    this.router = router;
    this.container = container;
    this.rootComponentId = rootComponentInputId;
    this.currentComponentId = currentComponentInputId;
    this.store = storeInput;
    this.activity = itemActivity;
    this.keyEventComponent = (rootComponentInputId ?? -1).toString() + '_' + EventConst.SHOWCOMPONENT;
    this.componentData = componentDataInput;

    const dsControl = new DisplayComponentControl(rootComponentInputId, currentComponentInputId, applicationId, applicationVersion, variableComponentInput, variableComponentHeaderInput, variableComponentModalInput, variableComponentParametersInput, container, this.updateData, this.getNode, this.showExp);

    this.rdControlId = (dsControl as any).id;

    this.addInput("ejecutar", new ClassicPreset.Input(socket, "Ejecutar", true));
    this.addControl(
      "value",
      dsControl

      //new ClassicPreset.InputControl("text", { initial })
    );

    this.addOutput("ejecutar", new ClassicPreset.Output(socket, "Ejecutar"));


    //area.update("control",dsControl.id)
    //this.addOutput("value", new ClassicPreset.Output(socket, "Valor"));





  }

  showExp = (evt: any) => {
    if (this.showExpression) {
      return this.showExpression(evt)
    }
    return null;
  }

  getNode = (key: string) => {
    if (this.getNodeInternalData) {
      return this.getNodeInternalData(this.id, key, true, false)
    }
    return null;
  }
  updateData = (evt: any) => {

    //this.value = evt
    //@ts-ignore:disable-next-line
    this.controls.value[evt.key] = evt.data;
    //this.controls[evt.key].valueConnection = evt.data;

    this.area.update("control", this.rdControlId)


    if (this.updateNode) {
      this.updateNode(this.id, evt.key, JSON.stringify(evt.data), true, false)
    }


  }

  resolveExpressions = () =>{
    const currentComp = this.componentData.find(x => x.id == this.currentComponentId)
        
        const WfData = currentComp?.workFlows.find(w => w.id == this.activity?.workFlowId )

        this.activity?.iapWorkFlowActivityControls.forEach((wcf: IapWorkFlowActivityControl) => {

          if (currentComp && wcf) 
          {
            
            if (wcf.name == DisplayComponentNodeConst.VAR_PARAM_IN) {
              this.variableParamsInput.forEach(param => {
                const keyParameters = '#' + wcf.id.toString() + '#parameterId=' + param.id;
                const exps = currentComp.expressions?.filter(x =>
                  x.idObjeto == CatalogObjectTypeConst.WFAC
                  && x.idTypeExpression == CatalogExpConst.EXP_SET
                  && x.iapExpressionDetails?.length > 0
                  && x.objetoId.endsWith(keyParameters));
                if (exps?.length > 0) {
                  exps?.every(exp => {
                    if (exp.iapExpressionDetails?.length > 0) {
  
                      const localData = LocalService.getValue(LocalService.COMPONENTS_EXP + (this.rootComponentId ?? -1).toString());
                      const data = JSON.parse(localData ?? '[]')
                      let resu = ExpresionEngine.resolveExpressions(exp.iapExpressionDetails, data as any)
                      //resu = resu?.toString();
                      if (resu) {
                        if (Object.keys(resu).length == 0) {
                          resu = resu?.toString();
                        }
                      }
  
                      param.value = resu;
  
  
                    }
                  })
  
                }
              })
            }
            else {
              const keyControl = CatalogObjectTypeConst.EVTCOMP + '#' + WfData?.objetoId + '#' + wcf.id.toString();
              
              const exps = currentComp.expressions?.filter(x =>
                x.idObjeto == CatalogObjectTypeConst.WFAC
                && x.idTypeExpression == CatalogExpConst.EXP_SET
                && x.iapExpressionDetails?.length > 0
                && x.objetoId == keyControl);
              if (exps?.length > 0) 
              {
                exps?.every(exp => {
                  if (exp.iapExpressionDetails?.length > 0) {

                    const localData = LocalService.getValue(LocalService.COMPONENTS_EXP + (this.rootComponentId ?? -1).toString());
                    const data = JSON.parse(localData ?? '[]')
                    let resu = ExpresionEngine.resolveExpressions(exp.iapExpressionDetails, data as any)
                    //resu = resu?.toString();
                    if (resu) {
                      if (Object.keys(resu).length == 0) {
                        resu = resu?.toString();
                      }
                    }

                    switch(wcf.name) {
                      case DisplayComponentNodeConst.VAR_HEADER_IN:
                        // code block
                        this.variableComponentHeader = resu
                        break;
                      case DisplayComponentNodeConst.VAR_COMPMODAL_IN:
                        this.variableComponentModal = resu;
                        // code block
                        break;
                      default:
                        // code block
                    }

                  }
                })

              }
  
            }
  
  
          }

        })
    
  }

  async execute(input: "ejecutar", forward: (output: "ejecutar") => void) {


    // vamos a buscar las expresiones si las hubiera
    
       this.resolveExpressions();

    // fin de resolver las expresiones



      var doCallbackOk = (response: boolean) => {
        //console.log('respuesta:' + compId.toString())
        if (response) {
          forward("ejecutar");
        }
      }
      EventBus.emit(this.keyEventComponent, { componentId: this.variableComponent, header: this.variableComponentHeader, modal: this.variableComponentModal, attrs: this.variableParamsInput, callBackResponse: doCallbackOk });



  }


  data(): { value: string } {
    return {
      //@ts-ignore:disable-next-line
      value: this.controls.value['value'] || ""
    };
  }
  /*
  data(): { connection: String, procName: String, parametersInput:[] } {
    return {
      connection: this.controls.value['variableconnection'] ?? '',
      procName: this.controls.value['variableprocName'] ?? '',
      parametersInput: this.controls.value['variableparamsInput'] ?? '',

    };
    
  }
  */
}